import { UpdateLayerConfig } from "../types/bulk-comparative-validator";
import { ResetAttributePayload, RoleWidgetInstanceConfigPayload, WidgetInstanceFormPayload } from "../types/widget-instance";
import { baseInstance } from "axios/instances";

export const getWidgetInstancesByRole = async (roleId: string) => {
    const res = await baseInstance.get(`/functionalities/funcsInstancefuncgroups/${roleId}`);
    return res.data;
};

export const getLayerConfigByInstance = async (instanceId: string) => {
    const res = await baseInstance.get(`/layerConfiguretion/GetLayerConfiguretionSORByInstenceId/${instanceId}`);
    return res.data;
};

export const getLayerConfigByInstanceAndSor = async (instanceId: string, sorId: string) => {
    const res = await baseInstance.get(`/layerConfiguretion/GetLayerConfiguretionSORByInstenceId/${instanceId}/${sorId}`);
    return res.data;
};

export const updateLayerConfig = async (payload: UpdateLayerConfig) => {
    const res = await baseInstance.post("/layerConfiguretion/InsertLayerConfiguretionSOR", payload);
    return res.data;
}

export const resetInstanceRules = async (payload: ResetAttributePayload) => {
    const res = await baseInstance.post("/attribute/resetattribute", payload);
    return res.data;
}

export const getWidgetInstancesWithRole = async () => {
    const res = await baseInstance.get(`/functionalities/funcWithRoleId`);
    return res.data;
};

export const getWidgetInstancesByClient = async (clientId: string) => {
    const res = await baseInstance.get(`/functionalities/funcSecondaryNameBySecIdAssign/${clientId}`);
    return res.data;
};

export const deleteWidgetInstance = async (instanceId: string) => {
    const res = await baseInstance.delete(`/widgetInstance/${instanceId}`);
    return res.data;
};

export const getWidgetInstanceById = async (instanceId: string) => {
    const res = await baseInstance.get(`/widgetInstance/${instanceId}`);
    return res.data;
};

export const createWidgetInstance = async (payload: WidgetInstanceFormPayload) => {
    const res = await baseInstance.post(`/widgetInstance`, payload);
    return res.data;
};

export const updateWidgetInstance = async (payload: WidgetInstanceFormPayload) => {
    const { instance_id, ...rest } = payload
    const res = await baseInstance.put(`/widgetInstance/${instance_id}`, rest);
    return res.data;
};

export const setRoleWidgetInstanceConfig = async (payload: RoleWidgetInstanceConfigPayload) => {
    const res = await baseInstance.post("/functionalities/setfunc", payload);
    return res.data;
};